import React, { FC } from 'react';
import { Coords } from 'google-map-react';

const Marker: FC<Coords> = ({ children }) => <>{children}</>;

export default Marker;
